import Vue from 'vue'
import Vuex from 'vuex'
import moduleConfigurator from "@/store/modules/moduleConfigurator";
import moduleBasket from "@/store/modules/moduleBasket";
import moduleFavorites from "@/store/modules/moduleFavorites";
import moduleCatalog from "@/store/modules/moduleCatalog";
import moduleEasyClean from "@/store/modules/moduleEasyClean";
import modulePolicy from "@/store/modules/modulePolicy";
import moduleOrdersHistory from "@/store/modules/moduleOrdersHistory";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    modules: {
        moduleConfigurator, moduleBasket, moduleFavorites, moduleCatalog, moduleEasyClean, modulePolicy,
        moduleOrdersHistory
    },
    actions: {}
})
